//================ User ==================
export const userLoginApi="/manager-login"
export const getUserProfileApi="/get-manager-profile"
export const managerFirstChangePasswordApi="/manager-first-change-password"
export const changePasswordApi="/user-change-password"

//================= User Api======================
export const addExchangeUserApi="/add-user-exchange-api"
export const getExchangeUserApi="/get-user-exchange-api"
export const getUserAccountApi="/get-user-account"
export const deleteUserExchangeApi="/delete-exchange-api"

//=================== Trader Card ==================
export const getTradeCardApi="/get-manager-trade-card"
export const getTradeCradByIdapi="/get-trade-card-by-id"

//====================== Place Order ===================
export const addOpenTradeApi="/open-trade"

//===================== Limit Order ========================
export const deleteLimitOrderApi="/delete-limit-order"